const variables = {
  fullStarColor: '#1cbbea',
  emptyStarColor: '#E3E4E4',
  strokeColor: '#1cbbea',
  shareCartSenderNameLength: 71,
};

export default variables;



// WEBPACK FOOTER //
// ./src/sparkle/variables.js